import styled, { css, CSSProperties } from 'styled-components'
import { Orientation } from '../types'
import { OVERLAYS_Z_INDEX } from '../constants'

type MeasurementLineProps = {
  $orientation: Orientation
  $x: number
  $y: number
  $lineSize: number
}

export const MeasurementLine = styled.div.attrs(
  ({ $x, $y, $orientation, $lineSize }: MeasurementLineProps) => {
    const style: CSSProperties = {
      transform: `translate(${$x}px, ${$y}px)`,
      width: $orientation === Orientation.Horizontal ? `${$lineSize}px` : '1px',
      height:
        $orientation === Orientation.Horizontal ? '1px' : `${$lineSize}px`,
    }
    return { style }
  }
)<MeasurementLineProps>`
  z-index: ${OVERLAYS_Z_INDEX.MEASUREMENT_LINE};
  position: absolute;
  background: ${({ theme }) => theme.colors.inspect.guide};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const MeasurementLineProjection = styled.div.attrs(
  ({ $x, $y, $orientation, $lineSize }: MeasurementLineProps) => {
    /* -0.5 to center on the line */
    const x = $x - 0.5
    const y = $y - 0.5

    const style: CSSProperties = {
      transform: `translate(${x}px, ${y}px)`,
      width: $orientation === Orientation.Horizontal ? `${$lineSize}px` : '1px',
      height:
        $orientation === Orientation.Horizontal ? '1px' : `${$lineSize}px`,
    }
    return { style }
  }
)<MeasurementLineProps>`
  z-index: ${OVERLAYS_Z_INDEX.MEASUREMENT_PROJECTION_LINE};
  position: absolute;
  ${({ $orientation }) => {
    if ($orientation === Orientation.Horizontal) {
      return css`
        border-top: 1px dashed red;
      `
    }
    return css`
      border-left: 1px dashed red;
    `
  }}
  display: flex;
  align-items: center;
  justify-content: center;
`

export const LineEndMark = styled.div<{
  $orientation: Orientation
  $side: 'start' | 'end'
}>`
  background: ${({ theme }) => theme.colors.inspect.guide};
  z-index: ${OVERLAYS_Z_INDEX.MEASUREMENT_LINE};
  position: absolute;
  ${({ $orientation, $side }) => {
    if ($orientation === Orientation.Horizontal) {
      return css`
        /* -0.5 to center on the line */
        left: ${$side === 'start' ? '-0.5px' : 'auto'};
        right: ${$side === 'end' ? '-0.5px' : 'auto'};
        height: 8px;
        width: 1px;
      `
    }

    return css`
      /* -0.5 to center on the line */
      top: ${$side === 'start' ? '-0.5px' : 'auto'};
      bottom: ${$side === 'end' ? '-0.5px' : 'auto'};
      width: 8px;
      height: 1px;
    `
  }}
`

export const MeasurementPill = styled.div<{
  $orientation: Orientation
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  font-size: 10px; /* stylelint-disable-line */
  padding: 3px 5px; /* stylelint-disable-line */
  border-radius: 6px;
  color: white;
  background: ${({ theme }) => theme.colors.inspect.guide};
  transform: ${({ $orientation }) =>
    $orientation === Orientation.Horizontal
      ? 'translateY(calc(-50% - 4px));'
      : 'translateX(calc(-50% - 4px));'};
`
